'use client';

import LegalLayout from '@/components/layout/LegalLayout';
import { useTranslations } from 'next-intl';
import { useState, useEffect } from 'react';

export default function AccessibilityPage() {
  const [mounted, setMounted] = useState(false);
  const [translations, setTranslations] = useState({
    title: '',
    commitmentTitle: '',
    commitment: '',
    featuresTitle: '',
    feature1: '',
    feature2: '',
    feature3: '',
    feature4: '',
    feature5: '',
    shortcutsTitle: '',
    shortcut1: '',
    shortcut2: '',
    shortcut3: '',
    shortcut4: '',
    feedbackTitle: '',
    feedback: '',
  });

  const t = useTranslations('accessibility');

  useEffect(() => {
    setMounted(true);
    // 设置翻译内容
    setTranslations({
      title: t('title'),
      commitmentTitle: t('commitmentTitle'),
      commitment: t('commitment'),
      featuresTitle: t('featuresTitle'),
      feature1: t('feature1'),
      feature2: t('feature2'),
      feature3: t('feature3'),
      feature4: t('feature4'),
      feature5: t('feature5'),
      shortcutsTitle: t('shortcutsTitle'),
      shortcut1: t('shortcut1'),
      shortcut2: t('shortcut2'),
      shortcut3: t('shortcut3'),
      shortcut4: t('shortcut4'),
      feedbackTitle: t('feedbackTitle'),
      feedback: t('feedback', { feedbackLink: t('feedbackCenter') }),
    });
  }, [t]);

  // 如果未挂载，显示加载状态
  if (!mounted) {
    return (
      <div className="animate-pulse space-y-4">
        <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-4/6"></div>
      </div>
    );
  }

  return (
    <LegalLayout pageTitle={translations.title} lastUpdated="2024-07-27">
      <section id="commitment">
        <h2>{translations.commitmentTitle}</h2>
        <p>{translations.commitment}</p>
      </section>
      <section id="measures">
        <h2>{translations.featuresTitle}</h2>
        <ul>
          <li>{translations.feature1}</li>
          <li>{translations.feature2}</li>
          <li>{translations.feature3}</li>
          <li>{translations.feature4}</li>
          <li>{translations.feature5}</li>
        </ul>
      </section>
      <section id="shortcuts">
        <h2>{translations.shortcutsTitle}</h2>
        <ul>
          <li>{translations.shortcut1}</li>
          <li>{translations.shortcut2}</li>
          <li>{translations.shortcut3}</li>
          <li>{translations.shortcut4}</li>
        </ul>
      </section>
      <section id="feedback">
        <h2>{translations.feedbackTitle}</h2>
        <p>{translations.feedback}</p>
      </section>
    </LegalLayout>
  );
}